import styled, { css } from "styled-components";

export const SubHeaderStyled = styled.header.attrs(() => ({
  className: "sub-header",
}))`
  ${({ theme }) => {
    const { colors, media } = theme;

    return css`
      align-items: center;
      display: flex;
      flex-direction: row;

      ${media.mobile.down} {
        align-items: center;
      }

      .subheader {
        &__text {
          line-height: 18px;
          font-size: 14px;
          line-height: 20px;

          .tooltip .tooltip-button svg {
            margin-right: 0;
          }

          ${media.mobile.down} {
            text-align: left;
          }
        }

        &__modal-link {
          background: none;
          border: none;
          padding: 0;
          color: ${colors.primary.gravity};
          font-size: 14px;
          line-height: 20px;
          text-decoration: underline;
          cursor: pointer;
          display: inline;
        }

        &__icon {
          min-width: 26px;
          min-height: 24px;
          margin-right: 12px;

          svg {
            fill: ${colors.primary.darkBlue};
          }
        }
      }
    `;
  }};
`;

const PageHeaderStyled = styled.header.attrs(() => ({
  className: "page-header",
}))`
  ${({ theme, isEeroPage }) => {
    const { colors, media } = theme;
    return css`
      .h1,
      .h2 {
        color: ${colors.primary.darkBlue};
        font-weight: ${isEeroPage ? 500 : 700};
        margin-bottom: 24px;
      }
      margin-bottom: ${isEeroPage ? "48px" : ""};
      p {
        font-weight: ${isEeroPage ? 700 : ""};
      }
      .portal-container {
        align-items: end;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        ${media.mobile.down} {
          .edit-address {
            display: none;
          }
        }
      }
      .page-header {
        &__titles {
          flex: 1 1 auto;

          ${media.tablet.up} {
            padding-right: 1rem;
          }

          h1,
          h2 {
            font-size: 32px;

            ${media.desktop.only} {
              font-size: 42px;
            }
          }
        }
      }
      .page-header__phone-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        ${media.tablet.up} {
          margin-bottom: 40px;
        }

        .h1 {
          margin-bottom: 0px;
        }
      }
    `;
  }};
`;

export default PageHeaderStyled;
